import forEach from "ramda/es/forEach";
import keys from "ramda/es/keys";
export function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
export function createLabeledMessages(messages) {
    const labeledMessages = {};
    forEach((key)=>{
        labeledMessages[`${key}_label`] = capitalizeFirstLetter(messages[key]);
    }, keys(messages));
    return labeledMessages;
}
export function unitJoin(value, unit) {
    return `$t(exp:unitJoin, {"unit":"${unit}", "value":"${value}"})`;
}
export function slashJoin(left, right) {
    return `$t(exp:slashJoin, {"left":"${left}", "right":"${right}"})`;
}
export function andJoin(left, right) {
    return `$t(exp:andJoin, {"left":"${left}", "right":"${right}"})`;
}
export function join(left, right) {
    return `$t(exp:join, {"left":"${left}", "right":"${right}"})`;
}
